import { DisplayName } from '@99designs/common/components/DisplayName';
import * as React from 'react';
import Avatar from './Avatar';
import AvatarCollection from './AvatarCollection';
import { Designer } from './User';

interface Props {
    users: Designer[];
}

const HeaderUserLayout = ({ users }: Props) => (
    <div className="header-user-layout">
        <div className="header-user-layout__item">{__('with')}</div>
        <div className="header-user-layout__item">
            {users.length === 1 ? (
                <Avatar userId={users[0].id} variations={['small', 'white-border']} />
            ) : (
                <AvatarCollection users={users} size={'small'} limit={7} />
            )}
        </div>
        <div className="header-user-layout__item">
            {users.length === 1 && (
                <DisplayName
                    user={{
                        name: users[0].displayName,
                        profileUrl: `/profiles/${users[0].id}`,
                    }}
                    isLinked={false}
                />
            )}
        </div>
    </div>
);

export default HeaderUserLayout;
